import { useState, useCallback } from 'react'

import { BulkAction, BulkActionFormField } from '@api/orval/apiHooks'
import { orvalFetch } from '@api/orvalFetcher'

interface BulkActionResponse {
  modal_title: string
  modal_description?: string
  submit_btn_txt: string
  fields: BulkActionFormField[]
  action: BulkAction
}

export const useBulkActionData = () => {
  const [data, setData] = useState<BulkActionResponse | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<unknown>(null)

  const fetchActionData = useCallback(async (path: string, method: string, action_name: string) => {
    if (!path || !method || !action_name) return

    setIsLoading(true)
    setError(null)

    try {
      const res = await orvalFetch<BulkActionResponse>({
        url: path,
        method: method as 'GET' | 'POST' | 'PATCH' | 'DELETE',
        params: { action_name },
      })
      setData(res)
    } catch (err) {
      console.error('Failed to fetch bulk action data:', err)
      setError(err)
    } finally {
      setIsLoading(false)
    }
  }, [])

  return { data, isLoading, error, fetchActionData }
}
